// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"379":"cc2159a4","426":"62e49357","715":"323fede9"}[chunkId] + ".chunk.css";
};